import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-900 text-white py-12 px-4" data-id="element-200">
      <div className="max-w-6xl mx-auto" data-id="element-201">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 text-center md:text-left" data-id="element-202">
          <div data-id="element-203">
            <h3 className="font-bold text-lg mb-4 text-slate-300" data-id="element-204">Contacto</h3>
            <p className="text-slate-400 flex items-center justify-center md:justify-start gap-2" data-id="element-205">
              <span data-id="element-206">📧</span> soporte@bibliotecaprofesional.com
            </p>
          </div>
          <div data-id="element-207">
            <h3 className="font-bold text-lg mb-4 text-slate-300" data-id="element-208">
              Redes Sociales
            </h3>
            <p className="text-slate-400 flex items-center justify-center md:justify-start gap-2" data-id="element-209">
              <span data-id="element-210">📲</span> @biblioteca.profesional
            </p>
          </div>
          <div data-id="element-211">
            <h3 className="font-bold text-lg mb-4 text-slate-300" data-id="element-212">Sitio Web</h3>
            <p className="text-slate-400 flex items-center justify-center md:justify-start gap-2" data-id="element-213">
              <span data-id="element-214">🌐</span> www.bibliotecaprofesional.com
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center" data-id="element-215">
          <p className="text-xs text-slate-500 max-w-3xl mx-auto leading-relaxed" data-id="element-216">
            © 2026 Biblioteca Profesional™ — Todos los derechos reservados.
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}